export enum EstruturaAmostragemLeituraTipoEnum {
    PENDULO = 'pendulo',
    DESCARGA = 'descarga',
}
